import React from 'react';

export default React.memo(function Toggle({ className = '', ...props }) {
  return (
    <input type={'checkbox'} {...props}
           className={`appearance-none w-12 h-6 overflow-hidden cursor-pointer rounded-full bg-gray checked:bg-lime-400 relative transition-all after:absolute after:transition-all after:w-5 after:h-5 after:rounded-full after:bg-white after:top-1/2 after:left-0.5 after:-translate-y-1/2 after:translate-x-0 checked:after:left-[calc(100%_-_2px)] checked:after:-translate-x-full active:after:w-7 after:ease-[cubic-bezier(0.54,1.60,0.5,1)] ${className}`} />
  );
})
